import React, { Component } from 'react';
import _ from 'lodash';

import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import MenuIcon from '@material-ui/icons/Menu';
import Select from 'react-select';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Input,
	Paper,
	InputBase,
	Divider,
	Grid,
	MenuItem,
	Chip
} from '@material-ui/core';
import {
	CloseOutlined as CloseIcon,
} from '@material-ui/icons';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { connect } from "react-redux";
import {
	  getRolesList,
  } from "../userManagement/actions/userActions";
  import { 
	  getUsers
 } from '../userManagement/actions/userActions';
 import {
	getClients,
  } from '../userManagement/actions/userActions';
 import {
	setPaginationToFirstPage,
  } from '../userManagement/actions/userActions';
 import {
	addRoleChip
  } from '../userManagement/actions/userActions';
 import {
	setRolesSearchActiveOption,
	setUsersSearchActiveOption,
	addUsersSearchChip,
	removeUsersSearchChip,
	setSearchQueryByTab,
	clearChips
  } from '../userManagement/actions/userActions';
  import { bindActionCreators } from "redux";

const styles = (theme: Theme) => createStyles({
	displayNone: {
		display: 'none'
	},
	inputWidth: {
		width: '62%'
	},
	root: {
		display: 'inline-block',
		width: 400,
		position: 'relative',
		'& .dropDown': {
			position: 'absolute',
			right: 10,
			top: 10,
			borderLeft: 'solid 1px rgb(188 188 188)',	
			height: 25		
		},
		'& .select': {
			height: 35,
			margin: '-8px 0px',			
			padding: '2px 2px 0px 0px',
			color: 'rgb(102 102 102)',
			width: 146,
			'&>:first-child': {
				border: 0,
				outline: 0,
				'&>:first-child': {
					'&:focus': {
						border: 0,
						outline: 0,
					}
				},
				'&>:nth-child(2)': {
					'&>:first-child': {
						border: 0,
						outline: 0,
					}
				}
			},
		}
	},
	widthMD: {
		width: '464px !important',
		'& input': {
			width: '62%'
		}
	},
	paper: {
		padding: `${theme.spacing.unit / 4}px ${theme.spacing.unit / 2}px`,
		display: 'flex',
		alignItems: 'center',
		width: 394,
		height: 44,
		boxShadow: '0px 0px',
		background: '#FFFFFF',
		border: '1px solid #DCDCDC',
		boxSizing: 'border-box',
		borderRadius: 34
	},
	input: {
		marginLeft: theme.spacing.unit,
		flex: 1,
		fontSize: '0.8rem',
		color: '#666666',
		'& > input': {
			fontFamily: 'Nunito',
			fontStyle: 'normal',
			fontWeight: 'normal',
			fontSize: 16,
			color: 'rgb(102 102 102)'
		}
	},
	iconButton: {
		padding: '10px 10px',
		opacity: 0.5,
		fontSize: theme.spacing.unit * 3,
		'& svg': {
			fontSize: 30
		},
		
	},
	suggestions:     
	{
		position: 'absolute',
		top: '100%',
		left: '13px',
		right: 0,
		maxHeight: '400px',
		overflow: 'auto',
		maxWidth:440,
		backgroundColor: "rgb(255 255 255)",
		boxShadow: "-1px 3px 4px 2px #bcbcbc",
		border: "solid 1px rgb(238 238 238)",
		zIndex:9,
		borderRadius:2,
		'& .filterItem': {
			'& li': {
				overflow: 'hidden',
				whiteSpace: 'nowrap',
				width: 360,
				textOverflow: 'ellipsis'
			}
		}
	}
	
});

//@ts-ignore
interface MyPATSearchBarProps extends WithStyles<typeof styles> {
	classes: any,
	searchText: string,
	searchTextChanged: Function,
	isSelect: boolean,
	isRolesTab: boolean,
	isUsersTab: boolean,
	rolesData: any,
	usersData: any,
	getRolesList: Function,
	getUsers: Function,
	setPaginationToFirstPage: Function,
	addRoleChip: Function,
	setRolesSearchActiveOption: Function,
	setUsersSearchActiveOption: Function,
	addUsersSearchChip: Function,
	usersSearchChipData: any,
	removeUsersSearchChip: Function,
	usersSearchData: any,
	usersSearchActiveOption: any,
	rolesSearchActiveOption: any,
	showCancelIcon: boolean,
	setSearchQueryByTab: Function,
	searchQuery: string,
	clearChips: Function
}
interface SelectedOption {
	value: string,
	label: string
}

interface RolesSearchObject {
	clients: string[],
	roles: string[]
}

interface UsersSearchObject {
	status: string,
	userDetails: string[],
	clients: string[],
	roles: string[]
}


interface SearchDataObject {
	searchText: string,
	rolesSearch?: RolesSearchObject,
	usersSearch?: UsersSearchObject
  }
interface MyPATSearchBarState {
	searchText: string,
	selectedOption: SelectedOption,
	rolesSearch: RolesSearchObject,
	showSuggestions: boolean,
	rolesChips: any,
}

const defaultSearchData = {
  searchText: '',
  rolesSearch: {
    clients: [],
    roles: []
  },
  usersSearch: {
    status: true,
    userDetails: [],
    clients: [],
    roles: []
  }
}



class MyPATSearchBar extends Component<MyPATSearchBarProps, MyPATSearchBarState>{

	constructor(props: MyPATSearchBarProps) {
		super(props);
		if (!props.searchText) {
			props = {
				...props,
				searchText: "",
			}
		}

		this.state = {
			searchText: !this.props.isRolesTab && !this.props.isUsersTab ? props.searchQuery : '',
			selectedOption: this.props.isRolesTab ? {value: this.props.rolesSearchActiveOption, label: this.props.rolesSearchActiveOption} : {value: this.props.usersSearchActiveOption, label: this.props.usersSearchActiveOption},
			rolesSearch:{
				clients: [],
				roles: []
			},
			showSuggestions: false,
			rolesChips: [],
		}

		this.handleSearchText = this.handleSearchText.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.handleEnterSearch = this.handleEnterSearch.bind(this);
		this.handleSearchClose = this.handleSearchClose.bind(this);
		this.handleSelectedOption = this.handleSelectedOption.bind(this);
		this.handleSuggestionClick = this.handleSuggestionClick.bind(this);
		this.renderChips = this.renderChips.bind(this);
	}
	

	componentDidUpdate(nextProps:MyPATSearchBarProps){
		if(nextProps.isRolesTab !== this.props.isRolesTab || nextProps.isUsersTab !== this.props.isUsersTab){
			this.setState({
				searchText: ''
			})
		}
	}

	// componentWillUnmount(){
	// 	// if(this.props.isRolesTab) {
	// 	// 	this.props.searchTextChanged(defaultSearchData)
	// 	// 	this.props.clearChips()
	// 	// }
	// 	// if(this.props.isUsersTab){
	// 	// 	this.props.searchTextChanged(defaultSearchData)
	// 	// 	this.props.clearChips()
	// 	// }
	// 	this.props.clearChips()
	// }

	handleSearchText(e: any) {
		let { value } = e.target;
		this.setState({ searchText: value, showSuggestions: true });
		console.log(this.state.selectedOption);

		// if(this.state.searchText === ""){
		// 	this.setState({
		// 		rolesSearch: { clients: [], roles: []},
		// 		usersSearch: { status: true, userDetails:[], clients:[], roles: []}
		// 	})
		// 	return;
		// }

		if(value === '') return;

		if(this.props.isRolesTab){
			switch(this.state.selectedOption.label){
				case "Client": 
				this.handleSuggestions(value);
				
					let updatedRolesSearchClients = {
						clients: [...this.state.rolesSearch.clients, value],
						roles:[...this.state.rolesSearch.roles]
					}
					// console.log(updatedRolesSearchClients)
					this.setState({
						rolesSearch: updatedRolesSearchClients
					})
					break;
				case "Roles": 
				this.handleSuggestions(value);
				
					let updatedRolesSearchRoles = {
						clients: [...this.state.rolesSearch.clients],
						roles:[...this.state.rolesSearch.roles, value]
					}
					console.log(updatedRolesSearchRoles)
					this.setState({
						rolesSearch:updatedRolesSearchRoles
					})
				
					break;
				default:
			}
		}
	}

	handleEnterSearch = (e: { key: string; }) => {
		if((!this.props.isRolesTab && !this.props.isUsersTab)) {
			if (e.key === 'Enter') {
				this.handleSearch();
			}
		}
	}

	handleSearchClose(e: any) {
		let { value } = e.target;
		this.setState({ searchText: value });
		if (this.props.searchTextChanged) {
			this.props.searchTextChanged('');
		}
	}

	handleSearch() {
		const { searchText } = this.state;
		// if (this.props.searchTextChanged) {
		// 	this.props.searchTextChanged(searchText);
		// }
		

		if(this.props.isRolesTab){
			this.props.searchTextChanged({
				rolesSearch: this.state.rolesSearch
			});
		} else if(this.props.isUsersTab){
			this.props.searchTextChanged({
				usersSearch: this.props.usersSearchData
			});
		} else {
			this.props.searchTextChanged({
				searchText: this.state.searchText,
			});
			// this.props.setSearchQueryByTab({
			// 	searchText : this.state.searchText, 
			// 	tab: 'Clients'
			// })
		}
		
	}

	getSelectOptions(){
		if(this.props.isRolesTab){
			return [
				{ value: 'Roles', label: 'Roles' },
				{ value: 'Client', label: 'Client' }]
		}

		if(this.props.isUsersTab){
			return [
				{ value: 'User Details', label: 'User Details' },
				{ value: 'Roles', label: 'Roles' },
				{ value: 'Status', label: 'Status' },
				{ value: 'Client', label: 'Client' }]
		}
	}

	handleSelectedOption(e: any){
		console.log(e);
		// let { value } = e.value;

		if(this.props.isRolesTab){
			this.updateRolesSearch(e);
			this.props.setRolesSearchActiveOption(e);
		}

		if(this.props.isUsersTab){
			this.props.setUsersSearchActiveOption(e);
		}

		this.setState({
			searchText: '',
			selectedOption: e
		})
	}

	updateRolesSearch = (e:{value: string, label: string}) => {
		// console.log(e.value)
		const {
			rolesSearch,
			rolesChips
		} = this.state;

		// console.log('rolesSearch------------>', rolesSearch)
		// console.log('rolesChips', rolesChips)
		if(rolesChips.length === 0) {
			let updatedrolesSearch = {...rolesSearch};
			switch(e.value){
				case 'Client':
						updatedrolesSearch.roles = [];
					break;
				case 'Roles':
						updatedrolesSearch.clients = [];
					break;
				default:
			}
			this.setState({
				rolesSearch: updatedrolesSearch
			}
			// , () => console.log(this.state.rolesSearch)
			)
		}
	}

	handleClickOutside = () => {
		this.setState({
			showSuggestions: false
		})
	}

	handleSuggestions = (searchText: string) => {
		
		if(this.props.isRolesTab){

			if(this.state.selectedOption.label === 'Roles'){
				// console.log(searchText);
				// console.log(this.props.rolesData.uniqueRoles)
				let roleSuggestions;
				if(this.props.rolesData.uniqueRoles) {
					roleSuggestions = this.props.rolesData.uniqueRoles.filter((role: string) => role.toString().toLowerCase().startsWith(searchText.toLowerCase()));
				}
				return this.renderSuggestionListItems(roleSuggestions)
				console.log(roleSuggestions);
				
			}

			if(this.state.selectedOption.label === 'Client'){
				// console.log(this.props.rolesData.uniqueClients)
				let clientSuggestions;
				if(this.props.rolesData.uniqueClients) {
					clientSuggestions = this.props.rolesData.uniqueClients.filter((client: string) => client.toString().toLowerCase().startsWith(searchText.toLowerCase()));
				}
				return this.renderSuggestionListItems(clientSuggestions)
				console.log(clientSuggestions);
			}

		}

		if(this.props.isUsersTab){

			if(this.state.selectedOption.label === 'Roles'){
				let roleSuggestions;
				if(this.props.usersData.uniqueRoles) {
					roleSuggestions = this.props.usersData.uniqueRoles.filter((role: string) => role.toString().toLowerCase().startsWith(searchText.toLowerCase()));
				}
				return this.renderSuggestionListItems(roleSuggestions)
				console.log(roleSuggestions);
			}

			if(this.state.selectedOption.label === 'Client'){
				let clientSuggestions;
				if(this.props.usersData.uniqueClients){
					clientSuggestions = this.props.usersData.uniqueClients.filter((client: string) => client.toString().toLowerCase().startsWith(searchText.toLowerCase()));
				}
				return this.renderSuggestionListItems(clientSuggestions)
			}

			if(this.state.selectedOption.label === 'User Details'){

				if(searchText.includes('@')){

					let userDetailSuggestionsEmails;
					if( this.props.usersData.uniqueEmails) {
						userDetailSuggestionsEmails = this.props.usersData.uniqueEmails.filter((email: string) => email.toString().toLowerCase().startsWith(searchText.toLowerCase()));
					}
					return this.renderSuggestionListItems(userDetailSuggestionsEmails);

				} 
				else {
					let userDetailSuggestionsUsers;
					if(this.props.usersData.uniqueUsers) {
						userDetailSuggestionsUsers = this.props.usersData.uniqueUsers.filter((user: string) => {
							if(user !== null){
								return user.toString().toLowerCase().startsWith(searchText.toLowerCase())
							}
							return;
						});
					}
					return this.renderSuggestionListItems(userDetailSuggestionsUsers);
				}
			}

			if(this.state.selectedOption.label === 'Status'){
				let statusSuggestions = ['Active', 'Inactive']
				this.props.usersSearchChipData.forEach((chip: string) => {
					if(chip === 'Active'){
						statusSuggestions = statusSuggestions.filter((status:string) => status === 'Active');
						console.log(statusSuggestions)
					}
					if(chip === 'Inactive'){
						statusSuggestions = statusSuggestions.filter((status: string) => status === 'Inactive');
						console.log(statusSuggestions)
					}
				})
				return this.renderSuggestionListItems(statusSuggestions);
			}
		}

	}

	handleSuggestionClick = (suggestion: any) => {
		// const { value } = e.target;
		console.log(suggestion);
		// console.log(e.target);
		// console.log(e.target.value);

		if(this.props.isRolesTab){

			if(this.state.selectedOption.label === 'Roles'){
				this.props.addRoleChip(suggestion);
				let updatedRolesSearchQuery = this.state.rolesSearch;
				let updatedChips = this.state.rolesChips;
				updatedChips.push(suggestion)
				updatedRolesSearchQuery.roles.push(suggestion);
				this.setState({
					rolesSearch: updatedRolesSearchQuery,
					showSuggestions: false,
					rolesChips: updatedChips
				}, () => this.handleSearch())
			}
	
			if(this.state.selectedOption.label === 'Client'){
				this.props.addRoleChip(suggestion);
				let updatedRolesSearchQuery = this.state.rolesSearch;
				let updatedChips = this.state.rolesChips;
				updatedChips.push(suggestion)
				updatedRolesSearchQuery.clients.push(suggestion);
				this.setState({
					rolesSearch: updatedRolesSearchQuery,
					showSuggestions: false,
					rolesChips: updatedChips
				}, () => this.handleSearch())
			}
		}

		if(this.props.isUsersTab){
			this.props.addUsersSearchChip(suggestion);
			this.setState({
				showSuggestions: false,
			}, () => this.handleSearch())
		}
	}

	renderSuggestionListItems(suggestionData: any) {
		if(suggestionData) {
			// console.log(suggestionData);
			if(suggestionData.length === 0){
				return <Grid className='filteritem'>
							<MenuItem 
								value='NO DATA'
								// onClick={() => this.handleSuggestionClick(suggestion)}
							>
										{`NO DATA`}
							</MenuItem>
						</Grid>
			}
			return suggestionData.map((suggestion: any) => {
				return <Grid className='filteritem'>
							        <MenuItem 
										value={suggestion}
										onClick={() => this.handleSuggestionClick(suggestion)}
									>
										{suggestion}
	                                </MenuItem>
							
						</Grid>
			})
		}
		return;
	}

	renderChips = () => {
		// <Chip
		// 	label='test'
		// 	onDelete={() => this.handleChipDelete('test')}
		// />
		if(this.props.isRolesTab){
			let chips:any = [];
			if(this.props.rolesData) {
				this.state.rolesChips.forEach((chip: string) => chips.push(
					<Chip
						label={chip}
						onDelete={() => this.handleChipDelete( chip)}
					/>
				));
			}
			return chips;
		}

		if(this.props.isUsersTab){
			let chips:any = [];
			

			this.props.usersSearchChipData.forEach((chip: string) => chips.push(
				<Chip
					label={chip}
					onDelete={() => this.handleChipDelete(chip)}
				/>
			))

			return chips;
		}
	}

	handleChipDelete = (chipText: string) => {
		if(this.props.isRolesTab){
			let updatedRolesTabChips = this.state.rolesChips;
			const index = updatedRolesTabChips.indexOf(chipText);
			updatedRolesTabChips.splice(index, 1);

			let updatedRolesSearchRoles = this.state.rolesSearch.roles;
			let updatedRolesSearchClients = this.state.rolesSearch.clients;
			updatedRolesSearchRoles = updatedRolesSearchRoles.map(role => role !== chipText && this.props.rolesData.uniqueRoles.includes(role) ?  role: '' );
			updatedRolesSearchClients = updatedRolesSearchClients.map(client => client !== chipText && this.props.rolesData.uniqueClients.includes(client) ? client: '');
			let updatedRolesSearch = this.state.rolesSearch;
			updatedRolesSearch.roles = updatedRolesSearchRoles;
			updatedRolesSearch.clients = updatedRolesSearchClients;

			this.setState({
				rolesChips: updatedRolesTabChips,
				rolesSearch: updatedRolesSearch
			}, () => {
				this.props.searchTextChanged({
				rolesSearch: this.state.rolesSearch
				})

				if(this.state.rolesChips.length === 0){
					this.setState({searchText: ''})
					this.props.getRolesList({pageNumber: 1, getDefaultRoles: false})
					this.props.setPaginationToFirstPage()
				}
			}
			
			)
		}

		if(this.props.isUsersTab){
			this.props.removeUsersSearchChip(chipText);
			this.setState({}, () => {
				this.props.searchTextChanged({
				usersSearch: this.props.usersSearchData
				})
				if(this.props.usersSearchChipData.length === 0) {
					this.setState({searchText: ''});
					this.props.getUsers({pageNumber: 1});
					this.props.setPaginationToFirstPage()
				}
			}
			
			)
		}
	}

	render() {
		const { classes, isSelect, isRolesTab, isUsersTab, showCancelIcon } = this.props;
		const { searchText } = this.state;
		// console.log(this.props.rolesData);
		// console.log(this.props.usersData);

		return (
			<>
				<div className={[classes.root, isSelect ? classes.widthMD : ''].join(' ')}>
					<Paper classes={{ root: [classes.paper, isSelect ? classes.widthMD : ''].join(' ') }} elevation={1}>

						{isSelect &&
							<Grid className="dropDown">
								<Select 
								className="select"
								components={{ IndicatorSeparator:() => null }}
								styles={
									{
										control: base => ({
										...base,
										border: 0,
										// This line disable the blue border
										boxShadow: "none"
									  })
									}
								}
								options={
									this.getSelectOptions()
								} 
								value={this.state.selectedOption}
								onChange={(e: any) => this.handleSelectedOption(e)}
								/>
							</Grid>
						}
						<IconButton className={classes.iconButton} aria-label="Search" onClick={this.handleSearch}>
							<img src="/assets/svg/myLibrary/search-icon.svg" alt="search-icon" />
						</IconButton>

						<InputBase 
							className={[classes.input, isSelect?classes.inputWidth: ''].join(' ')} 
							value={searchText} onChange={this.handleSearchText} 
							onKeyDown={this.handleEnterSearch} 
							placeholder="Search" />

						{ (this.props.isRolesTab || this.props.isUsersTab) && this.state.showSuggestions && 
						<ClickAwayListener onClickAway={this.handleClickOutside}>
							<Grid className={classes.suggestions}>
								{this.handleSuggestions(this.state.searchText)}
							</Grid>
						</ClickAwayListener>
						}
						{
						 (searchText || showCancelIcon) && 
						
							<IconButton onClick={(e: any) => { e.target.value = ""; this.handleSearchClose(e); }} 
							className={!isSelect ? classes.iconButton : classes.displayNone}>
								<CloseIcon />
							</IconButton>
						
						 }
					</Paper>
						{ (this.state.rolesChips.length > 0 || this.props.usersSearchChipData.length > 0) && 
							!isRolesTab &&
						<Grid>
							{this.renderChips()}
						</Grid>}
				</div>
			</>
		);
	}
}


const mapStateToProps = (state: any) => ({
	rolesData: state.clientManagement.rolesManagement.rolesData,
	usersData: state.clientManagement.usersManagement.allUsersdata,
	searchQuery: state.clientManagement.usersManagement.searchQuery,
	usersSearchChipData: state.clientManagement.usersManagement.usersChips,
	usersSearchData: state.clientManagement.usersManagement.usersSearchData,
	usersSearchActiveOption: state.clientManagement.usersManagement.usersSearchActiveOption,
	rolesSearchActiveOption: state.clientManagement.rolesManagement.rolesSearchActiveOption,
  });
  
//   const mapDispatchToProps = {
// 	getClients,
// 	getRolesList,
// 	getUsers,
// 	setPaginationToFirstPage,
// 	addRoleChip,
// 	setRolesSearchActiveOption,
// 	setSearchQueryByTab
//   };

  const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	getClients,
	getRolesList,
	getUsers,
	setPaginationToFirstPage,
	addRoleChip,
	setRolesSearchActiveOption,
	setUsersSearchActiveOption,
	addUsersSearchChip,
	removeUsersSearchChip,
	setSearchQueryByTab,
	clearChips
  }, dispatch);


export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(MyPATSearchBar));

